import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "../components/AppShell";
import { AppLoader, ButtonLoader } from "../components/Loaders";
import { getBootstrapStatus, importLatestBackup } from "../api/budgetPortal";
import { useAuth } from "../state/AuthContext";

const BudgetBootstrapPage = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [statusData, setStatusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [importing, setImporting] = useState(false);
  const [error, setError] = useState("");

  const loadStatus = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await getBootstrapStatus(token);
      setStatusData(response?.data ?? null);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        err.message ||
        "Unable to load bootstrap status",
      );
    }

    setLoading(false);
  };

  useEffect(() => {
    loadStatus();
  }, []);

  return (
    <AppShell title="Budget Bootstrap">
      <div className="page-grid">
        <section className="panel">
          <h2>Desktop backup import</h2>
          <p>
            This phase imports accounting year data from the latest desktop backup
            so the web budget module can use it for prior-year actuals and year
            cards.
          </p>

          {error ? <div className="alert alert--error">{error}</div> : null}

          {loading ? (
            <AppLoader label="Loading bootstrap status..." />
          ) : (
            <>
              <div className="stat-grid">
                <div className="stat-card">
                  <span>Available backups</span>
                  <strong>{statusData?.available_backups?.length || 0}</strong>
                </div>
                <div className="stat-card">
                  <span>Imported accounting years</span>
                  <strong>
                    {statusData?.imported_accounting_years?.length || 0}
                  </strong>
                </div>
                <div className="stat-card">
                  <span>Workspace years</span>
                  <strong>{statusData?.workspace_years?.length || 0}</strong>
                </div>
              </div>

              <div className="panel__actions">
                <button
                  type="button"
                  disabled={importing || !statusData?.latest_backup}
                  onClick={async () => {
                    setImporting(true);
                    setError("");

                    try {
                      await importLatestBackup(token);
                      await loadStatus();
                    } catch (err) {
                      setError(
                        err?.response?.data?.message ||
                        err.message ||
                        "Unable to import the latest backup",
                      );
                    }

                    setImporting(false);
                  }}
                >
                  {importing ? (
                    <ButtonLoader label="Importing..." />
                  ) : (
                    "Import latest desktop backup"
                  )}
                </button>

                <button
                  type="button"
                  className="button-secondary"
                  onClick={() => navigate("/budget-entry")}
                >
                  Continue
                </button>
              </div>

              <div className="backup-list">
                <h3>Latest backup</h3>
                {statusData?.latest_backup ? (
                  <div className="backup-item">
                    <strong>{statusData.latest_backup.device}</strong>
                    <span>{statusData.latest_backup.latestBackup}</span>
                    <code>{statusData.latest_backup.latestBackupPath}</code>
                  </div>
                ) : (
                  <p>No backup is available for this organization yet.</p>
                )}
              </div>
            </>
          )}
        </section>
      </div>
    </AppShell>
  );
};

export default BudgetBootstrapPage;
